export default __webpack_public_path__ + "static/media/emoji3.e27e2039.svg";